export const xAxisLabelStyles = {
  position: "bottom",
  offset: 0,
  fontWeight: 700,
  fill: "black",
};
export const yAxisLabelStyles = {
  position: "insideBottomLeft",
  angle: -90,
  fontWeight: 700,
  fill: "black",
};
